import {useEffect, useMemo, useState} from "react";
import {useMe} from "../../../hooks/useGetUser";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import Loader from "../shared/Loader";
import FranceMap from "../Map/FranceMap";
import {
  formatPostalEntryLabel,
  isValidInterventionZoneCode,
  normalizePostalSearch,
} from "../../../utils/postal";

const ModifProfileZones = ({isActive}) => {
  const [zoneError, setZoneError] = useState(false);
  const [query, setQuery] = useState("");
  const [postalData, setPostalData] = useState([]);
  const [selectedZone, setSelectedZone] = useState(null);
  const {data, isLoading} = useMe();
  const {onAddZone, onDeleteZone} = useUpdateTechnician();

  useEffect(() => {
    let isMounted = true;

    fetch("/data/interventionZones_sorted.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Impossible de charger les zones d'intervention");
        }
        return response.json();
      })
      .then((zones) => {
        if (isMounted) {
          setPostalData(zones);
        }
      })
      .catch(() => {
        if (isMounted) {
          setPostalData([]);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const suggestions = useMemo(() => {
    const normalizedQuery = normalizePostalSearch(query);

    if (!normalizedQuery || selectedZone) {
      return [];
    }

    return postalData
      .filter((item) => {
        const city = normalizePostalSearch(item.nom_de_la_commune);
        return (
          String(item.code_postal).startsWith(normalizedQuery) ||
          city.includes(normalizedQuery)
        );
      })
      .slice(0, 20);
  }, [postalData, query, selectedZone]);
  if (isLoading) {
    return <Loader />;
  }

  if (!isActive) {
    return null;
  }

  const handelZone = () => {
    const zoneCode = selectedZone?.code_postal || "";

    if (!selectedZone || !isValidInterventionZoneCode(zoneCode)) {
      setZoneError(true);
      return;
    }

    onAddZone([
      ...data?.Technician?.InterventionAreas.map((ele) => ele.code),
      zoneCode,
    ]);
    setQuery("");
    setSelectedZone(null);
    setZoneError(false);
  };

  const handleQueryChange = (event) => {
    setQuery(event.target.value);
    setSelectedZone(null);
    setZoneError(false);
  };

  const handleSelectZone = (item) => {
    setQuery(formatPostalEntryLabel(item));
    setSelectedZone(item);
    setZoneError(false);
  };

  return (
    <div className=" flex flex-col md:flex-row gap-4">
      <div className="w-full md:w-1/2 flex flex-col justify-start p-6 items-start h-full gap-4 ">
        <h6 className="font-semibold text-xl"> Zones d'intervention</h6>

        <h4 className="text-left font-normal text-base text-[#848484]">
          Ajoutez une zone
        </h4>
        <div className="relative w-full">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handelZone();
            }}
            className="flex justify-start items-center w-full border-2 border-solid rounded-xl p-1"
          >
            <input
              type="text"
              placeholder="Rechercher par ville ou code postal"
              className="form-control !pr-2 !border-none flex-grow"
              value={query}
              onChange={handleQueryChange}
              autoComplete="off"
            />
            <button
              type="submit"
              className="bg-[#1A64B9] w-11 inset-y-0 h-11 rounded-md flex justify-center text-white items-center cursor-pointer"
              aria-label="Ajouter la zone sélectionnée"
            >
              <i className="fi fi-rr-map-marker-plus flex justify-center items-center"></i>
            </button>
          </form>
          {suggestions.length > 0 && (
            <div className="absolute left-0 right-0 z-50 mt-1 max-h-72 overflow-y-auto rounded-lg border border-[#dddddd] bg-white shadow-lg">
              {suggestions.map((item) => (
                <button
                  key={`${item.code_commune_insee}-${item.code_postal}-${item.nom_de_la_commune}`}
                  type="button"
                  onClick={() => handleSelectZone(item)}
                  className="block w-full border-b border-[#eeeeee] px-4 py-3 text-left text-sm text-[#19295C] last:border-b-0 hover:bg-[#f4f7ff]"
                >
                  {formatPostalEntryLabel(item)}
                </button>
              ))}
            </div>
          )}
        </div>
        {zoneError && (
          <div className="text-red-500 text-sm">
            Veuillez entrer un code postal valide{" "}
          </div>
        )}
        <div className="flex gap-3 flex-wrap justify-start items-center">
          {data?.Technician?.InterventionAreas.length
            ? data?.Technician?.InterventionAreas.map((ele) => (
                <div className=" bg-gradient-to-r from-[#0022AA1A] to-[#1A64B91A] gap-2  font-bold text-sm  rounded-3xl px-4 py-2 flex justify-center items-center text-[#1A64B9] ">
                  {ele.code}{" "}
                  <i
                    className="fi fi-rr-cross-small flex justify-center items-center cursor-pointer"
                    onClick={() => onDeleteZone([ele.id])}
                  ></i>
                </div>
              ))
            : null}
        </div>
      </div>
      <div className="w-full  md:block md:w-1/2 p-6 ">
        <FranceMap
          highlightedPostCodes={data?.Technician?.InterventionAreas?.map(
            (ele) => ele.code
          )}
        />
      </div>
    </div>
  );
};

export default ModifProfileZones;
